import { render, staticRenderFns } from "./integral.vue?vue&type=template&id=50ac861c&scoped=true"
import script from "./integral.vue?vue&type=script&lang=js"
export * from "./integral.vue?vue&type=script&lang=js"
import style0 from "./integral.vue?vue&type=style&index=0&id=50ac861c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ac861c",
  null
  
)

export default component.exports